import React, { useContext, useEffect } from 'react';

import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

import { RootStoreContext } from 'index';
import Spinner from 'components/common/Spinner/Spinner';
import { ApplicationRoute } from 'routes/routes.enums';
import ConfirmationCode from 'components/common/ConfirmationCode/ConfirmationCode';

import styles from './EnterConfirmationCodePage.module.scss';

const EnterConfirmationCodePage = () => {
  const navigator = useNavigate();
  const { authStore, intermediaryApplicationsStore } = useContext(RootStoreContext);
  const {
    authStore: { isLoading, account, isSuccessValidation },
  } = useContext(RootStoreContext);

  const sendVerificationCode = async () => {
    await authStore.sendVerificationCode();
  };

  const verifyVerificationCode = async (code: string) => {
    const response = await authStore.verifyVerificationCode(code);

    if (response.success) {
      const companyProfile = await intermediaryApplicationsStore.getCompanyProfile();

      await authStore.getAccount();

      const firstAuthenticatedPath = !companyProfile.masterDealerAgreementWasSigned
        ? ApplicationRoute.AccountStatus
        : ApplicationRoute.Home;

      navigator(firstAuthenticatedPath);
      authStore.setAuthenticated();
    }
  };

  useEffect(() => {
    sendVerificationCode();
  }, []);

  return isLoading ? (
    <Spinner />
  ) : (
    <div className={styles.main}>
      <h3 className={styles.title}>Email Verification</h3>
      <p className={styles.text}>Let’s verify your Email.</p>
      <p className={styles.text}> We've sent a 6-digit verification code to {account?.email}.</p>
      <ConfirmationCode
        sendVerificationCode={sendVerificationCode}
        verifyVerificationCode={verifyVerificationCode}
        codeLength={6}
        isSuccessCode={isSuccessValidation}
      />
    </div>
  );
};

export default observer(EnterConfirmationCodePage);
